<template lang="pug">
	#registration.admin.theme-1
		section.material-half-bg
			.cover

		section.login-content.row.px-sm-5
			.col-12.logo: h1 

			.login-box.mb-5.col-md-8.col-lg-6
				h1.pt-4.text-center.text-primary(style='cursor: pointer;' @click.prevent='$router.replace("/")') INNOVIDERS
				h6.border-bottom.pb-3.text-center Be a Member!
				form-wizard(@on-complete='onComplete' title="" subtitle="")
					tab-content(title='Personal Details' icon='fa fa-user' v-bind:before-change="validatePersonalDetails")
							ValidationObserver(ref="ValidatorPersonalDetail")
								.row
									.col-md-8
										.form-group
											ValidationProvider(rules='required' v-slot='{errors}' name='branch' v-bind:customMessages='{is:"branch is invalid"}')
												label.control-label COOP NAME/BRANCH <span class="text-danger">*</span>
												v-select(v-model='form.coop_id' placeholder='Select branch' v-bind:options='coops' label='name' v-bind:reduce='option => option.id')
													template(#option="{ name, branch_name }")
														h6.m-0 {{name}}
														small {{branch_name}}
												small.text-danger(v-for='error in errors') {{error}}
									//- .col-md-6
										.form-group
											ValidationProvider(v-bind:rules='`required`' v-slot='{errors}' name='BARCODE' v-bind:customMessages='{is:"COOP ID is invalid"}')
												label.control-label BARCODE
												//- .input-group
													input.form-control(type="text", autofocus v-model="form.barcode" @blur='checkCoop')
													.input-group-append(v-show='CID_isConfirmed')
														span.input-group-text
															i.fa.fa-check.text-success
												input.form-control(type="text", autofocus v-model="form.barcode" @blur='checkCoop')
												small.text-danger(v-for='error in errors') {{error}}
									.col-md-4
										.form-group
											ValidationProvider(rules='required|numeric' v-slot='{errors}' name='coop id' v-bind:customMessages='{numeric: "coop id should be numeric."}')
												label.control-label CID <span class="text-danger">*</span>
												//- .input-group
													input.form-control(type="text", autofocus v-model="form.cid" @blur='checkCoop')
													.input-group-append(v-show='CID_isConfirmed')
														span.input-group-text
															i.fa.fa-check.text-success
												input.form-control(type="text", autofocus v-model="form.cid" placeholder='coop id here')
												small.text-danger(v-for='error in errors') {{error}}
									.col-sm-6
										.form-group
											ValidationProvider(rules='required' v-slot='{errors}' name='first name')
												label.control-label FIRST NAME <span class="text-danger">*</span>
												input.form-control(type="text" v-model="form.firstname" placeholder='firstname here')
												small.text-danger(v-for='error in errors') {{error}}
									.col-sm-6
										.form-group
											ValidationProvider(rules='' v-slot='{errors}' name='middle name')
												label.control-label MIDDLE NAME 
												input.form-control(type="text" v-model="form.middlename" placeholder='middlename here')
												small.text-danger(v-for='error in errors') {{error}}
									.col-sm-12
										.form-group
											ValidationProvider(rules='required' v-slot='{errors}' name='last name')
												label.control-label LAST NAME <span class="text-danger">*</span>
												input.form-control(type="text" v-model="form.lastname" placeholder='lastname here')
												small.text-danger(v-for='error in errors') {{error}}
									.col-sm-6
										.form-group
											ValidationProvider(rules='required' v-slot='{errors}' name='birthdate')
												label.control-label BIRTH DATE <span class="text-danger">*</span>
												date-picker(v-model='form.birthdate' valueType="format" format='YYYY-MM-DD' placeholder='Click to select date' input-class='form-control' class='w-100')
												//- input.form-control(type="text" ref='ElBirthDate' v-model="form.birthdate")
												small.text-danger(v-for='error in errors') {{error}}
									.col-sm-6
										.form-group
											ValidationProvider(rules='required|numeric|min:10' v-slot='{errors}' name='contact number' v-bind:customMessages='{min: "constact number should have 10 digit.", numeric: "constact number should be numeric."}')
												label.control-label CONTACT NUMBER <span class="text-danger">*</span>
												.input-group
													.input-group-prepend
														.input-group-text +63
													input.form-control(type="text" v-model="form.contact_number" placeholder='9#########')
												small.text-danger(v-for='error in errors') {{error}}
							</ValidationObserver>

					tab-content(title='Additional Info' icon='fa fa-cog' v-bind:before-change="validatorPlace")
						ValidationObserver(ref='ValidatorPlace')
							.row
								.col-12
									.form-group
										ValidationProvider(rules='required' v-slot='{errors}' name='birth place')
											label.control-label BIRTH PLACE <span class="text-danger">*</span>
											textarea.form-control(v-model='form.birth_place')
											small.text-danger(v-for='error in errors') {{error}}
								.col-12
									.form-group
										ValidationProvider(rules='required' v-slot='{errors}' name='current address')
											label.control-label CURRENT ADDRESS <span class="text-danger">*</span>
											textarea.form-control(v-model='form.current_address')
											small.text-danger(v-for='error in errors') {{error}}
								.col-12
									.form-group
										ValidationProvider(rules='required' v-slot='{errors}' name='permanent address')
											label.control-label PERMANENT ADDRESS <span class="text-danger">*</span>
											textarea.form-control(v-model='form.permanent_address')
											small.text-danger(v-for='error in errors') {{error}}
						
					tab-content(title='Last Step' icon='fa fa-check')
						ValidationObserver(ref='ValidatorAccount')
							.row
								.col-12.mb-3
									ValidationProvider(rules='required|image|max_arr_length:3' v-slot='{errors, failed}' name='identification card' class='row' tag='div')
										.col-12
											file-upload(ref='FilesIdentification' v-bind:multiple='true' accept='image/png,image/gif,image/jpeg,image/webp' @input-filter="inputFilter" v-model='form.files' class='w-100 p-5 border' v-bind:class='{"border-danger": failed}')
												<h3 class="dropzone-custom-title text-primary"><i class="fa fa-cloud-upload-alt"></i> Drag and drop to upload content!</h3>
												<div class="subtitle">Add Selfie and Identification Card</div>
										.col-12(v-if='errors.length')
											small.text-danger(v-for='error in errors') {{error}}
								.col-12.mb-3(v-show='form.files.length')
									table.table.table-sm
										thead
											tr
												th Thumb
												th Name
												th Action
										tbody
											tr(v-for='(image, index) in form.files')
												td
													img(v-bind:src='image.thumb' width='40' height="auto")
												td {{image.name}}
												td.text-danger
													button.btn.btn-sm.btn-danger(type='button' @click.prevent='removeFile(image.id)') remove

									//- ValidationProvider(rules='required' v-slot='{errors}' name='identification card')
										<vue-dropzone ref="Dropzone" id="dropzone" v-bind:options="dropzoneOptions" v-bind:useCustomSlot=true>
											<div class="dropzone-custom-content">
												<h3 class="dropzone-custom-title text-primary">Drag and drop to upload content!</h3>
												<div class="subtitle">Add Selfie and Identification Card</div>
											</div>
										</vue-dropzone>
								.col-12
									.form-group
										ValidationProvider(rules='required|email' v-slot='{errors}' name='Username')
											label.control-label USERNAME <span class="text-danger">*</span>
											input.form-control(type="text", v-model="form.username" placeholder='Username here')
											small.text-danger(v-for='error in errors') {{error}}
								.col-12
									.form-group
										ValidationProvider(rules='required|min:8|alpha_num_specialcase' v-slot='{errors}' name='password' v-bind:customMessages='{min: "Password must be 8 characters and more."}')
											label.control-label PASSWORD <span class="text-danger">*</span>
											.input-group
												input.form-control(v-bind:type="isShowPass?'text':'password'", v-model="form.password" placeholder='Password here')
												.input-group-append
													button.btn.btn-secondary(@click.prevent='isShowPass=!isShowPass')
														i.fa.fa-eye.m-0(v-show='!isShowPass')
														i.fas.fa-eye-slash.m-0(v-show='isShowPass')
											small.text-danger(v-for='error in errors') {{error}}
								.col-12
									.form-group
										ValidationProvider(v-bind:rules='`required|is:${form.password}`' v-slot='{errors}' name='confirm password' v-bind:customMessages='{is: "Confirm Password does not match"}')
											label.control-label CONFIRM PASSWORD <span class="text-danger">*</span>
											.input-group
												input.form-control(v-bind:type="isShowConfirmPass?'text':'password'", v-model="form.confirm_pass")
												.input-group-append
													button.btn.btn-secondary(@click.prevent='isShowConfirmPass=!isShowConfirmPass')
														i.fa.fa-eye.m-0(v-show='!isShowConfirmPass')
														i.fas.fa-eye-slash.m-0(v-show='isShowConfirmPass')
											small.text-danger(v-for='error in errors') {{error}}
				.text-center.pb-5.border-top.pt-3
					a(href='javascript:void(0)' @click.prevent='$router.push("/")'): b Already have an Account? Click here!
</template>

<script>
import $ from 'jquery'
import faker from 'faker'
import moment from 'moment'
// import {extend} from 'vee-validate'

// extend('alpha_num_specialcase', (value) => {
// 	// console.log('isConfirmed', value, isConfirmed)
// 	if(!/^(?=.*\d)(?=.*[A-Z]).+$/.test(value))
// 		return true

// 	return 'The {_field_} must have 1 uppercase and number.'
// });
export default {

	name: 'registration',

	data () {
		return {
			coops: [],
			CID_isConfirmed: false,

			isShowPass: false,
			isShowConfirmPass: false,

			dropzoneOptions:{
				url: 'https://httpbin.org/post',
				acceptedFiles: "image/*",
        addRemoveLinks: true,
				thumbnailWidth: 150,
        // maxFilesize: 0.5,
        // headers: { "My-Awesome-Header": "header value" },
        dictDefaultMessage: '<i class="fa fa-cloud-upload-alt"></i> Selfie and Identification Card'
			},

			form: {
				files: [],
				cid              :'',
				coop_id          :'',
				firstname        :'',
				middlename       :'',
				lastname         :'',
				birthdate        :'',
				contact_number   :'',
				birth_place      :'',
				current_address	 :'',
				permanent_address:'',
				username         :'',
				password         :'',
				confirm_pass     :'',
			}
		}
	},


	mounted() {
		this.$swal({
			text: 'Initializing. . .',
			allowOutsideClick: false
		})
		this.$swal.showLoading()
		this.$http.get('coops')
			.then(response=> {
				this.coops=response.data
			})
			.finally(() => {
				if(process.env.NODE_ENV==='development') {
					this.$http.get('microbanker/clients')
						.then(response => {
							// console.log(response)
							const client = faker.random.arrayElement(response.data)
							// console.log(client)
							this.form.cid=client.CID.trim()
							this.form.firstname=client.FirstName.trim()
							this.form.middlename=client.MiddleName.trim()
							this.form.lastname=client.LastName.trim()
							this.form.birthdate        =moment(client.BirthDate).format('YYYY-MM-DD')
						})
						.finally(() => {
							// this.form.coop_num         =faker.random.arrayElement(this.coops.map(coop=>coop.id)),
							this.form.coop_id=faker.random.arrayElement(this.coops.map(coop=>coop.id))
							this.form.contact_number   =faker.helpers.replaceSymbols('##########')
							this.form.birth_place      =faker.address.streetAddress()
							this.form.current_address	 =faker.address.streetAddress()
							this.form.permanent_address=faker.address.streetAddress()
							this.form.username         =faker.internet.email()
							this.form.password         ='1nn0videR5'
							this.form.confirm_pass     ='1nn0videR5'
						})
				}
				this.$nextTick(() => {
					this.$swal.close()
				})
			})

		
	},

	methods: {
		/**
		 * [removeFile description]
		 * @param  {[type]} index [description]
		 * @return {[type]}       [description]
		 */
		removeFile(id) {
			this.form.files=this.form.files.filter(file => file.id!==id)
		},


		/**
		 * [inputFilter description]
		 * @param  {[type]} newFile [description]
		 * @param  {[type]} oldFile [description]
		 * @param  {[type]} prevent [description]
		 * @return {[type]}         [description]
		 */
		inputFilter(newFile, oldFile, prevent) {
			if(this.form.files.find(item => item.name==newFile.name)){
				prevent()
			}
			if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
				newFile.blob = ''
				let URL = window.URL || window.webkitURL
				if (URL && URL.createObjectURL) {
					newFile.blob = URL.createObjectURL(newFile.file)
				}
			}
			newFile.thumb = ''
			if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
				newFile.thumb = newFile.blob
			}
		},


		/**
		 * [validatorPlace description]
		 * @return {[type]} [description]
		 */
		validatorPlace() {
			return this.$refs.ValidatorPlace.validate()
		},


		/**
		 * [validatePersonalDetails description]
		 * @return {[type]} [description]
		 */
		validatePersonalDetails() {
			return new Promise((resolve, reject) => {
				this.$refs.ValidatorPersonalDetail.validate()
					.then(success => {
						if(!success) {
							reject(false)
						}

						this.$http.post('member/validation/information-exists', {
							'coop_id' : this.form.coop_id,
							'cid' : this.form.cid,
							'firstname' : this.form.firstname,
							'lastname' : this.form.lastname,
							'birthdate' : this.form.birthdate,
						})
						.then(response => {
							resolve(true)
						})
						.catch(response => {
							reject(false)
							this.$swal({
								icon: 'error',
								title: 'Oops! Validation',
								text: 'Invalid credentials!'
							})
						})
					})
			})
		},


		/**
		 * [checkCoop description]
		 * @return {[type]} [description]
		 */
		/*checkCoop() {
			this.CID_isConfirmed=false
			if(!this.form.cid)
				return false
			
			this.$http.get('microbanker/clients/check/'+this.form.cid)
				.then(response => {
					console.log(response)

					this.CID_isConfirmed=response.body
				})
		},*/


		/**
		 * [onComplete description]
		 * @return {[type]} [description]
		 */
		onComplete() {
			this.$refs.ValidatorAccount.validate()
				.then(success => {
					if(!success){
						this.$swal({
							icon: 'error',
							title: 'Validator!',
							text: 'Please check your inputs!'
						})
						return
					}

					this.$swal({
						text: 'Member Registration is on process . . .',
						allowOutsideClick: false
					})
					this.$swal.showLoading()

					let formData = new FormData()

					Object.keys(this.form).forEach(key => {
						if(key!=='files') {
							formData.append(key, this.form[key])
						} else {
							this.form[key].forEach(file => {
								formData.append('files[]', file.file)
							})
						}
					})
					this.$http.post('member',formData)
						.then(response => {
							const self=this
							this.$swal({
								icon: 'success',
								title: 'Success!',
								html: `
									<div class="text-center">
										Your membership was successfully created.
										<br>
										Contact your COOP to confirm your registration.
									</div>
								`,
								onClose(){
									self.$router.replace('/')
								}
							})
						})
						.catch(response => {
							console.log(response)
							const data=response.body

							switch(response.status) {
								case 422:
									const errors=data.errors

									let errorMsg=Object.keys(errors).map(errKey=> {
										return errors[errKey].map(err=>'<li>'+err+'</li>').join('')
									})
									this.$swal({
										icon: 'error',
										title: 'Validation!',
										html: `
											<ul class="text-left">
												${errorMsg.join('')}
											</ul>
										`
									})
									break

								default:
									this.$swal({
										icon: 'error',
										title: 'Oops!',
										text: 'Something wen\'t wrong!'
									})
							}
						})
						.finally(() => {
							// this.$swal.close()
						})
					/*setTimeout(() => {
						this.$swal.close()
					}, 2000)*/
				})
		},
	}
}
</script>

<style lang="scss" scoped>
	.login-box {
		// min-width: 700px !important;
		min-height: 100vh !important;
	}
	.dz-image {
		border-radius: 0px;
		img {
			width: 100%;
		}
	}
</style>